import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { withProfile } from 'app/modules/profile'

import { profileUrl, visibility } from 'app/modules/profile/selectors'
import { fetchMeetingSettings, updateMeetingSettings } from 'app/modules/meetings/actions'
import { getMeetingSettings, getMeetingSettingsStatus } from 'app/modules/meetings/selectors'

import BufferSettings from './component'

function mapStateToProps(state) {
  return {
    meetingSettings: getMeetingSettings(state),
    meetingStatus: getMeetingSettingsStatus(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchMeetingSettings,
        updateMeetingSettings,
      },
      dispatch
    ),
  }
}

export default compose(
  withProfile({ profileUrl, visibility }),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchMeetingSettings()
    },
  }),
  withHandlers({
    handleSelectMinimumNoticeTime: ({ meetingSettings, actions }) => ({ value }) => {
      actions.updateMeetingSettings(meetingSettings.set('minimumNoticeTime', value))
    },
    handleSelectBufferTime: ({ meetingSettings, actions }) => ({ value }) => {
      actions.updateMeetingSettings(meetingSettings.set('bufferTime', value))
    },
  })
)(BufferSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/BufferSettings/index.js